
import SinAuth from "../templates/SinAuth";
import ContenidoPublico from "../templates/ContenidoPublico";

import { connect } from "react-redux";
import dynamic from 'next/dynamic';

import BlocksFormatoPendienteFromExternalPortal from "../components/BlocksFormatoPendienteFromExternalPortal";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";

import React from 'react';

//import { configSubdomain, useAuthDispatch, logout, useAuthState } from '../context';


const FormatoPendiente = (props) => {
        console.log("FormatoPendiente.js");

        //const dispatch = useAuthDispatch();
        //const userDetails = useAuthState();

        //const { subdomain, userName, idSuscripcion, idEmpresa, idioma } = userDetails;
          
    return (
        <ContenidoPublico>
            <BlocksFormatoPendienteFromExternalPortal />
        </ContenidoPublico>
    );
};

//export default FormatoPendiente;
export default dynamic(() => Promise.resolve(connect(null)(FormatoPendiente)), {ssr: false});